import { render, staticRenderFns } from "./specialtyInfo.vue?vue&type=template&id=6ac4e88a&scoped=true"
import script from "./specialtyInfo.vue?vue&type=script&lang=js"
export * from "./specialtyInfo.vue?vue&type=script&lang=js"
import style0 from "./specialtyInfo.vue?vue&type=style&index=0&id=6ac4e88a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4e88a",
  null
  
)

export default component.exports